import React, { useContext} from 'react';
import { UserContext } from '../../App';
//import Navbar from '../Navbar/Navbar';
import "../../css/style.css";

const Status = () => {

    const [status, setStatus] = useContext(UserContext);
    
    return (

        <div className='container__home'>
{/*            <Navbar></Navbar>*/}
            <div className='status' >
                <h3 className='status-h3'>Status of Server API</h3>
                <pre className='status-json'>
                    {JSON.stringify(status, null,' ')?.replace('[', '').replace(']', '')}
                </pre>
                
            </div>
        </div>
    );
};

export default Status;